import { render, staticRenderFns } from "./WarningNotice.vue?vue&type=template&id=2d1abb3d&scoped=true"
import script from "./WarningNotice.vue?vue&type=script&lang=js"
export * from "./WarningNotice.vue?vue&type=script&lang=js"
import style0 from "./WarningNotice.vue?vue&type=style&index=0&id=2d1abb3d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1abb3d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d1abb3d')) {
      api.createRecord('2d1abb3d', component.options)
    } else {
      api.reload('2d1abb3d', component.options)
    }
    module.hot.accept("./WarningNotice.vue?vue&type=template&id=2d1abb3d&scoped=true", function () {
      api.rerender('2d1abb3d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/component/WarningNotice.vue"
export default component.exports